// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { RequirePermission } from "@/components/shared/require-permission";
import { ChainSettingsCompare } from "@/features/chains/chain-settings-compare";
import { PAGE_PERMISSIONS } from "@/lib/auth/page-permissions";

export const Route = createFileRoute("/_authenticated/chains/compare/$chainNameA/$chainNameB")({
  component: ChainCompare,
});

function ChainCompare() {
  const { chainNameA, chainNameB } = Route.useParams();
  return (
    <RequirePermission permission={PAGE_PERMISSIONS.chains}>
      <ChainSettingsCompare chainNameA={chainNameA} chainNameB={chainNameB} />
    </RequirePermission>
  );
}
